import React from 'react';
import { Sparkles, Award, Crown } from 'lucide-react';

export const LuxuryShowcaseSection = () => {
  const showcaseImages = [
    {
      url: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600&q=80',
      title: 'Professional Salon Excellence',
      subtitle: 'Premium Hair Cutting Tools'
    },
    {
      url: 'https://images.unsplash.com/photo-1622287162716-f311baa18128?w=600&q=80',
      title: 'Gold Plated Luxury',
      subtitle: '24K Gold Finish Collection'
    },
    {
      url: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&q=80',
      title: 'Barbershop Heritage',
      subtitle: 'Classic Shaving Excellence'
    },
    {
      url: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&q=80',
      title: 'Manicure Perfection',
      subtitle: 'Rose Gold Beauty Tools'
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden border-y border-gray-200">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Luxury header */}
        <div className="text-center mb-16">
          <div className="flex justify-center items-center gap-3 mb-4">
            <Crown className="w-8 h-8 text-yellow-600 animate-pulse" />
            <h2 className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 via-yellow-600 to-yellow-700">
              Luxury Craftsmanship
            </h2>
            <Crown className="w-8 h-8 text-yellow-600 animate-pulse" />
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Experience the epitome of beauty instrument excellence
          </p>
        </div>

        {/* Image showcase grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {showcaseImages.map((item, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
              style={{
                animationDelay: `${index * 0.2}s`
              }}
            >
              <div className="aspect-square relative">
                <img
                  src={item.url}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Gold overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
                
                {/* Sparkle effect on hover */}
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <Sparkles className="w-6 h-6 text-yellow-400 animate-pulse" />
                </div>
                
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-white font-bold text-lg mb-1">{item.title}</h3>
                  <p className="text-yellow-400 text-sm font-medium">{item.subtitle}</p>
                </div>

                {/* Gold border effect */}
                <div className="absolute inset-0 border-2 border-yellow-500/0 group-hover:border-yellow-500/50 rounded-2xl transition-all duration-300"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Luxury features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center p-8 rounded-xl bg-gradient-to-b from-yellow-50 to-white border border-yellow-200 transform hover:scale-105 transition-all duration-300">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/50">
              <Award className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Premium Materials</h3>
            <p className="text-gray-600">Crafted from the finest Japanese & German steel</p>
          </div>

          <div className="text-center p-8 rounded-xl bg-gradient-to-b from-yellow-50 to-white border border-yellow-200 transform hover:scale-105 transition-all duration-300">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/50">
              <Sparkles className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Gold & Chrome Finish</h3>
            <p className="text-gray-600">24K gold plating & mirror chrome perfection</p>
          </div>

          <div className="text-center p-8 rounded-xl bg-gradient-to-b from-yellow-50 to-white border border-yellow-200 transform hover:scale-105 transition-all duration-300">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/50">
              <Crown className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Handcrafted Excellence</h3>
            <p className="text-gray-600">Precision engineering by master craftsmen</p>
          </div>
        </div>
      </div>
    </section>
  );
};
